// frontend/src/utils/letterStimulus.ts
// Helpers for the LETTER (letter recall) PVT stimulus type.

const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

const randomLetter = (): string => ALPHABET[Math.floor(Math.random() * ALPHABET.length)];

/** Pick `count` distinct random uppercase letters (A-Z). */
export const generateTargetLetters = (count = 3): string[] => {
  const letters = new Set<string>();
  while (letters.size < count) {
    letters.add(randomLetter());
  }
  return [...letters];
};

/**
 * Build a 5-letter stimulus. With ~50% probability exactly one of the
 * target letters is included; otherwise no target letters are present.
 */
export const generateStimulusLetters = (
  targets: string[]
): { letters: string[]; hasTarget: boolean } => {
  const includeTarget = targets.length > 0 && Math.random() < 0.5;
  const letters = new Set<string>();

  if (includeTarget) {
    letters.add(targets[Math.floor(Math.random() * targets.length)]);
  }

  const excluded = new Set(includeTarget ? letters : targets);
  while (letters.size < 5) {
    const candidate = randomLetter();
    if (!excluded.has(candidate) && !letters.has(candidate)) {
      letters.add(candidate);
    }
  }

  return { letters: [...letters], hasTarget: includeTarget };
};
